import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { addToCart } from "../actions/cartActions";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ProductCard = ({ product }) => {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const dispatch = useDispatch();

    const handleImageChange = (index) => {
        setCurrentImageIndex(index);
    };

    const handleAddToCart = () => {
        dispatch(addToCart(product));

        toast.success("¡Agregado al carrito!", {
            position: "top-center",
            autoClose: 500,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
        });
    };

    const formatPrice = (price) => {
        return new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS' }).format(price);
    };

    return (
        <div className="flex flex-col items-center text-center">
            <div
                className="relative w-full max-w-xs"
                onMouseEnter={() => handleImageChange((currentImageIndex + 1) % product.images.length)}
                onClick={() => handleImageChange((currentImageIndex + 1) % product.images.length)}
            >
                <img
                    src={product.images[currentImageIndex]}
                    alt={`${product.name} ${currentImageIndex + 1}`}
                    className="w-full h-full object-cover"
                    style={{ width: '365px', height: '665px' }}
                />
            </div>
            <h2 className="mt-4 font-bold text-lg text-center font-bold text-white">{product.name}</h2>
            <p className="text-center font-bold text-white">{formatPrice(parseFloat(product.price.replace(/[^\d.-]/g, '')))}</p>
            <button
                onClick={handleAddToCart}
                className="px-4 py-2 border border-white rounded-full text-white mt-4"
            >
                Añadir al carrito
            </button>
            <ToastContainer className="toast-container" />
        </div>
    );
};

export default ProductCard;
